module.exports = __webpack_public_path__ + "img/avatar_40.c7369b51.svg";